import { createIcon } from '../utils';

export const DocumentIcon = createIcon(
  ({ ref, className, width = 142, height = 185, ...rest }) => (
    <svg
      ref={ref}
      className={className}
      width={width}
      height={height}
      viewBox="0 0 142 185"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#document-icon-clip)">
        <path
          d="M123.456 18.4971C126.538 18.5023 129.636 18.4868 132.713 18.4971C133.47 50.3541 133.47 82.2111 132.713 114.068L132.342 114.84H28.2603L27.7809 114.068L28.5541 114.506C28.7757 115.777 28.9045 119.685 27.7809 120.23L28.152 119.458H132.239L132.718 120.23C133.981 120.864 133.929 125.651 132.718 126.398L132.347 127.17H28.2603L27.7809 126.398L28.5541 126.836C28.7757 128.107 28.9045 132.015 27.7809 132.56L28.152 131.788H132.239L132.718 132.56C133.981 133.194 133.929 137.981 132.718 138.728L132.347 139.5H28.2603L27.7809 138.728L28.5541 139.165C28.7757 140.437 28.9045 144.344 27.7809 144.89L28.152 144.118H132.239L132.718 144.89C133.017 144.973 133.46 145.096 133.491 145.338C133.615 146.321 133.671 152.86 133.491 153.575L132.718 154.136C125.688 155.006 118.616 155.089 111.56 154.564C112.04 160.463 111.761 166.368 111.112 172.248L110.746 173.02H18.9984L18.5191 172.248C18.5088 170.327 18.5191 168.392 18.5191 166.466C18.3077 162.358 18.117 158.25 17.983 154.136C17.849 150.023 17.7202 145.915 17.715 141.806C17.6377 100.559 17.6326 59.3171 18.0655 18.0647C53.2163 17.3079 88.3465 17.4469 123.461 18.492L123.456 18.4971Z"
          fill="#F1F1F1"
        />
        <path
          d="M18.5186 166.477H0V0H123.456V18.4974C88.48 18.4151 53.489 18.5592 18.5134 18.4974C18.6011 67.817 18.4001 117.157 18.5134 166.477H18.5186Z"
          fill="#F0F9FA"
        />
        <path
          d="M132.718 18.4972C135.8 18.5075 138.898 18.492 141.98 18.4972L142.006 153.225L141.593 154.533L140.325 155.058C138.068 154.821 135.795 154.775 133.522 154.914L132.718 154.152V144.906C131.455 144.272 131.507 139.485 132.718 138.738V132.571C131.455 131.937 131.507 127.15 132.718 126.403V120.236C131.455 119.602 131.507 114.815 132.718 114.068V18.4972Z"
          fill="#D9E6E7"
        />
        <path
          d="M111.112 172.258C112.014 176.14 112.472 180.938 111.498 184.588L110.189 185L18.5188 184.974C18.5085 180.742 18.5394 176.49 18.5188 172.253H111.112V172.258Z"
          fill="#D9E6E7"
        />
        <path
          d="M132.718 154.147C135.583 154.147 138.861 153.823 141.593 154.533L111.498 184.593C110.859 184.192 111.112 183.131 111.106 182.478C111.07 179.075 111.117 175.661 111.112 172.258C111.112 166.225 111.112 160.176 111.112 154.142C118.307 154.152 125.522 154.142 132.718 154.142V154.147Z"
          fill="#B8D3D5"
        />
        <path
          d="M94.1346 40.0789C114.179 52.9288 113.122 81.5733 94.7479 95.7411C86.1509 102.372 73.6883 105.306 63.6533 100.194C57.7416 98.2328 51.2784 89.9133 48.923 84.2709C37.0222 55.7448 65.782 27.2805 94.1294 40.0789H94.1346Z"
          fill="#009999"
        />
        <path
          d="M132.712 114.068H27.7754V120.236H132.712V114.068Z"
          fill="#B8D3D5"
        />
        <path
          d="M132.712 126.398H27.7754V132.566H132.712V126.398Z"
          fill="#B8D3D5"
        />
        <path
          d="M132.712 138.729H27.7754V144.896H132.712V138.729Z"
          fill="#B8D3D5"
        />
        <path
          d="M63.6582 100.193C96.1495 110.984 122.451 70.8488 99.3502 45.0822L94.1343 40.0781C126.394 54.6423 117.307 102.448 82.7489 104.811C76.497 105.239 68.7762 103.833 63.6582 100.193Z"
          fill="#2B6664"
        />
        <path
          d="M79.8675 61.6543L80.6406 61.4742L89.6963 52.4133L98.7365 61.5153C98.8757 62.303 90.8611 69.3663 89.9179 70.7615L98.7365 80.2908C97.1491 81.4697 91.2219 88.6514 90.0055 88.9758C89.4695 89.1148 89.2994 88.914 88.9077 88.6566C87.5058 87.7145 81.0374 80.1621 80.4396 80.1621C77.646 82.2368 74.667 86.8444 71.9714 88.6566C71.5797 88.9191 71.4096 89.1199 70.8736 88.9758C69.6572 88.6566 63.7352 81.4749 62.1426 80.2908L70.9612 71.0446C71.0591 70.6946 70.7808 70.5504 70.6262 70.3136C69.049 67.966 63.3692 64.1358 62.2869 62.0353C61.9983 61.4793 62.1993 61.469 62.4776 61.0623C64.4052 58.2617 68.9923 55.2706 71.1828 52.4082C73.9609 55.5074 77.677 58.1742 79.8726 61.6492L79.8675 61.6543Z"
          fill="#F1F1F1"
        />
      </g>
      <defs>
        <clipPath id="document-icon-clip">
          <rect width="142" height="185" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  { displayName: 'DocumentIcon' },
);
